import axios from "axios";

const GET_MAP_SETTINGS = "GET_MAP_SETTINGS";
const POPULATE_MAP_SETTINGS = "POPULATE_MAP_SETTINGS";

export const ACTION_POPULATE_MAP_FROM_DB = `maps/${GET_MAP_SETTINGS}`;

export var state = {
  accessToken: null,
  points: null
};

export let getters = {
  points: state => {
    return state.points;
  }
};

export const mutations = {
  [POPULATE_MAP_SETTINGS]: (state, settings) => {
    state.points = settings.points;
    state.accessToken = settings.accessToken;
  }
};
export const actions = {
  [GET_MAP_SETTINGS]: async ({ commit }) => {
    let response = await axios.post("/api/pcs/maps", {
      params: {
        pcs: localStorage.getItem("pcs")
      }
    });
    return commit(POPULATE_MAP_SETTINGS, JSON.parse(response.data[0].settings));
  }
};
